import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { shallowEqual } from 'react-redux';
import { isConfigFlagEnabled } from '../../config';
import { selectIsSimpleBettingEnabled } from '../../redux/reducers/pokerReducer';
import { selectSideBettingState } from '../../redux/selectorFns';
import { useAppSelector } from '../../redux/store';
import { DomAutoBetControls } from './controls/dom/domAutoBetControls';
import { DomSideBetButton } from './controls/dom/domSideBetButton';
import { DomSimpleBetControls } from './controls/dom/domSimpleBetControls';
import { DomSitInButton } from './controls/dom/domSitInButton';
import { DomStandardBetControls } from './domStandardBetControls';
const CONTAINER_CSS = css `
  position: absolute;
  left: 0;
  top: 0;
`;
export const DomBetControlsRouter = () => {
    const isSimpleBettingEnabled = useAppSelector(selectIsSimpleBettingEnabled);
    const isMyDiscardTurn = useAppSelector((state) => state.poker.isMyDiscardTurn);
    const myTurnProperties = useAppSelector((state) => state.poker.myTurnProperties, shallowEqual);
    const isMyAutoBetTurn = useAppSelector((state) => !!state.poker.autoBetProperties);
    const sideBettingState = useAppSelector(selectSideBettingState);
    const isSelfSittingOut = useAppSelector((state) => state.poker.isSelfSittingOut);
    const sitInButtonBounds = useAppSelector((state) => state.gameDimensions.sitInButtonBounds, shallowEqual);
    const sideBetButtonBounds = useAppSelector((state) => state.gameDimensions.sideBetButtonBounds, shallowEqual);
    if (isSelfSittingOut) {
        if (!isConfigFlagEnabled('domBetButtons')) {
            return null;
        }
        if (!sitInButtonBounds) {
            return null;
        }
        return _jsx(DomSitInButton, { bounds: sitInButtonBounds });
    }
    if (sideBettingState === 'available') {
        if (!isConfigFlagEnabled('domBetButtons')) {
            return null;
        }
        if (!sideBetButtonBounds) {
            return null;
        }
        return _jsx(DomSideBetButton, { bounds: sideBetButtonBounds });
    }
    if (isMyDiscardTurn) {
        // TODO?
        return null;
    }
    if (myTurnProperties) {
        return (_jsx("div", { css: CONTAINER_CSS, children: isSimpleBettingEnabled ? (_jsx(DomSimpleBetControls, { myTurnProperties: myTurnProperties })) : (_jsx(DomStandardBetControls, { myTurnProperties: myTurnProperties })) }));
    }
    /**
     * TODO: Enable auto betting controls with simple betting, which requires aligning button bounds so unintended
     * betting actions won't occur if the buttons change as the player is about to click something.
     */
    if (isMyAutoBetTurn && !isSimpleBettingEnabled) {
        return _jsx(DomAutoBetControls, {});
    }
    return null;
};
